// | This module defines foreign types and functions for working with
// | the jQuery library.
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Foreign from "../Foreign/index.js";
import {
  append,
  appendText,
  attr,
  before,
  body,
  clear,
  clone,
  cloneWithDataAndEvents,
  closest,
  create,
  css,
  deafen,
  delegate,
  find,
  getAttrImpl,
  getCurrentTarget,
  getHtml,
  getMetaKey,
  getPageX,
  getPageY,
  getProp,
  getTarget,
  getText,
  getValue,
  getWhich,
  hasClass,
  off,
  on,
  parent,
  preventDefault,
  ready,
  remove,
  select,
  setAttr,
  setClass,
  setHtml,
  setProp,
  setText,
  setValue,
  setVisible,
  stopImmediatePropagation,
  stopPropagation,
  toArray,
  toggle,
  toggleClass,
  unsafeAppendHtml
} from "./foreign.js";
const removeClass = cls => setClass(cls)(false);
const on$p = delegate;
const off$p = deafen;
const hide = /* #__PURE__ */ setVisible(false);
const getAttr = str => jq => {
  const $0 = getAttrImpl(str)(jq);
  return () => {
    const a$p = $0();
    return Foreign.isUndefined(a$p) ? Data$dMaybe.Nothing : Data$dMaybe.$Maybe("Just", a$p);
  };
};
const display = /* #__PURE__ */ setVisible(true);
const addClass = cls => setClass(cls)(true);
export {addClass, display, getAttr, hide, off$p, on$p, removeClass};
export * from "./foreign.js";
